<template>
  <ZigzagServiceLayout
    mainTitle="Harmonização Facial e Injetáveis"
    mainDescription="Redescubra o seu brilho. Nossos tratamentos especializados em neurotoxinas e preenchimentos são desenvolvidos para suavizar rugas e restaurar o volume, realçando os seus traços."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'FacialHarmonizationContentPtBR',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ANTI-ENVELHECIMENTO',
          title: 'Neurotoxinas (Botox/Dysport)',
          subtitle: 'Suaviza linhas finas e rugas de expressão.',
          paragraphs: [
            "As neurotoxinas, como Botox e Dysport, oferecem uma maneira segura e eficaz de suavizar temporariamente as rugas dinâmicas causadas por movimentos.",
            "Ao relaxar os músculos, esses tratamentos suavizam pés de galinha e linhas da testa, deixando-a com uma aparência revigorada e descansada."
          ],
          list: [
            "Procedimento rápido e minimamente invasivo",
            "Aponta para linhas de expressão e rugas",
            "Os resultados geralmente duram de 3 a 4 meses",
            "Previne a formação de rugas mais profundas"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/dsy8tUMNyIs',
            'https://www.youtube.com/embed/LM2IEIQ-mC8'
          ]
        },
        {
          label: 'VOLUME E CONTORNO',
          title: 'Preenchedores Dérmicos',
          subtitle: 'Restaure o volume perdido e melhore os contornos.',
          paragraphs: [
            "Com o envelhecimento, nossa pele perde sustentação e volume. Os preenchimentos usam ácido hialurônico para preencher maravilhosamente a pele por baixo.",
            "Se você deseja realçar os lábios, definir as maçãs do rosto ou preencher as dobras profundas ao redor da boca, os preenchimentos proporcionam lifting imediato."
          ],
          list: [
            "Restaura o volume jovem nas bochechas e nos lábios",
            "Suaviza linhas profundas e dobras da face",
            "Resultados imediatos, visíveis e naturais",
            "Os efeitos podem durar de 6 a 18 meses"
          ],
          image: '/images/services/facial-harm.png'
        }
      ]
    };
  }
};
</script>
